/*
 * @Author: wanglidong
 * @Date: 2021-07-12 15:30:44
 * @LastEditTime: 2021-07-20 16:55:37
 * @LastEditors: your name
 * @Description:
 * @FilePath: \jhMobile\src\assets\upload\upload.js
 * @nbsg
 */
/**
 * Created by shenguolin on 2021/6/22 17:25
 * jhMobile
 * Description:
 */
import Vue from 'vue'
import { Toast } from 'vant'
import store from '../../store'

export default {
  previewFile(e) {
    let that = Vue.prototype
    store.state.loading = true
    that.$httpPost(
      store.state.httpHost.file + `/japi/filesystem/getFilePreview?id=${e}&browserType=1`,
    ).then(res => {
      window.location.href = res.data.url.replace("/file",store.state.httpHost.file)
      // window.open(res.data.url.replace("/file",store.state.httpHost.file))
    }).catch(res => {
      console.log('请求出现错误',res);
      Toast('请求失败!')
    }).finally(res=>{
      store.state.loading = false
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/upload/upload.js